{
  "slug": "ravens-progressive-matrices",
  "title": "Raven’s Progressive Matrices Explained",
  "description": "Visual patterns assess nonverbal reasoning, but “culture reduced” does not mean culture free.",
  "category": "Science of testing",
  "sections": [
    {
      "heading": "Definition and role",
      "paragraphs": [
        "Visual patterns assess nonverbal reasoning, but “culture reduced” does not mean culture free.",
        "The construct is inferred from performance across selected tasks; it is not directly observed."
      ]
    },
    {
      "heading": "Assessment",
      "paragraphs": [
        "Professional interpretation considers standardized administration, age norms, reliability, validity, and confidence intervals.",
        "Language, motor and sensory access, education, culture, fatigue, and health matter."
      ]
    },
    {
      "heading": "Limits",
      "paragraphs": [
        "No task captures the full construct. Combine results with history and real-world functioning.",
        "Online examples illustrate formats but do not reproduce secure professional materials."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "iq-vs-intelligence"],
  "sources": [],
  "faqs": [],
  "summary": "Visual patterns assess nonverbal reasoning, but “culture reduced” does not mean culture free. Content reviewed 18 July 2026."
}
